import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_play",
  "use": "icon-icon_play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_play\">\n    <path d=\"M409.6 742.4l307.2-230.4-307.2-230.4v460.8zM512 0C229.376 0 0 229.376 0 512s229.376 512 512 512 512-229.376 512-512S794.624 0 512 0z m0 921.6c-225.792 0-409.6-183.808-409.6-409.6S286.208 102.4 512 102.4s409.6 183.808 409.6 409.6-183.808 409.6-409.6 409.6z\" p-id=\"2640\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol